const routes = {
  '/dashboard': 'Bảng tổng hợp thông tin',
  '/admin-db': 'Truy cập trực tiếp database',
  '/field-master-data': 'Field Master Data',
  '/email-sender': 'Email đại diện gửi notification',
  '/report-issue': 'Báo lỗi cho lập trình viên',
  '/docs': 'Các tài liệu của hệ thống Houselink',
  '/upload-file': 'Upload file lên server Houselink',

  '/users/list': 'Danh sách  Người dùng',
  '/users/import': 'Tạo thêm Người dùng',

  '/contractors/list': 'Contractor List',
  '/contractors/list-ticket': 'Danh sách Nhà thầu cần claim',
  // '/contractors/list-approved': 'Danh sách Nhà thầu đã xác thực',
  // '/contractors/list-not-approved': 'Danh sách Nhà thầu chưa xác thực',
  // '/contractors/list-not-approved-update': 'Danh sách Nhà thầu chưa xác thực update',
  '/contractors/import': 'Tạo thêm Nhà thầu',

  '/projects/list': 'Project List',
  // '/projects/list-approved': 'Danh sách Dự án đã xác thực',
  // '/projects/list-not-approved': 'Danh sách Dự án chưa xác thực',
  // '/projects/list-not-approved-update': 'Danh sách Dự án chưa xác thực qua update',
  '/projects/import': 'Tạo thêm Dự án',
  '/project/:id': 'Chi tiết dự án',
  '/projects/list-answer': 'Danh sách bộ câu trả lời',
  '/projects/answer/:id': 'Chi tiết bộ câu trả lời',

  '/bidding/list': 'Bidding List',
  // '/bidding/list-approved': 'Danh sách hạng mục đấu thầu đã duyệt',
  // '/bidding/list-not-approved': 'Danh sách hạng mục đấu thầu chưa được duyệt',
  // '/bidding/list-not-approved-update': 'Danh sách hạng mục đấu thầu chưa được duyệt update',
  '/bidding/:id': 'Chi tiết bidding',

  '/products/list': 'Product List',
  // '/product/list-approved': 'Danh sách Sản phẩm đã xác thực',
  // '/product/list-not-approved': 'Danh sách Sản phẩm chưa xác thực',
  // '/product/list-not-approved-update': 'Danh sách Sản phẩm chưa xác thực qua update',
  '/product/import': 'Tạo thêm Sản phẩm',
  '/product/:id': 'Chi tiết Sản phẩm',

  '/user/:id': 'Chi tiết Người dùng',

  '/contacts/list': 'Danh sách Liên hệ',
  '/contacts/import': 'Nhập contact',
  '/contacts/:id': 'Contact detail',

  '/orders/list': 'Order List',
  // '/orders/completed': 'Danh sách Orders đã xong',
  // '/orders/waiting': 'Danh sách Orders đang chờ thanh toán',
  // '/orders/canceled': 'Danh sách Orders đã hủy',
  // '/orders/failed-to-charge': 'Danh sách Orders bị lỗi thanh toán',
  // '/orders/in-process': 'Danh sách Orders đang tiến hành',
  // '/orders/shipped': 'Danh sách Orders đã ship',
  '/order/:id': 'Chi tiết đơn hàng',

  '/master/membership': 'Membership',

  '/ticket/:id': 'Chi tiết Ticket',

  '/others/slide-shop': 'Slide Shop',

  '/tutorials': 'Video hướng dẫn',
  
  '/system-notification': 'Thông báo của hệ thống',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js